import { useCallback, useEffect } from "react";
import { CordwoodHistory, CreateCordwoodHistory, UpdateCordwoodHistory } from "../types/models/CordwoodHistory.d";
import { UpdateEntityCordwoodHistory } from "../types/models/CordwoodHistory";
import { useGetCordwoodHistoryListQuery, useInsertCordwoodHistoryMutation, useDeleteCordwoodHistoryMutation, } from "../apis/CordwoodHistory.api";
import { useDeleteDialog, useDescriptionAlert } from '../../share';
import { useNavigate } from "react-router";
import { t } from "@lingui/core/macro";

export default function useCordwoodHistory(page: number, pageSize: number) {

    const navigate = useNavigate()
    const { openDialog, closeDialog } = useDeleteDialog();

    const { openSuccessAlert, openFailAlert } = useDescriptionAlert()

    const [insertCordwoodHistoryMutation, { 
        isLoading: insertCordwoodHistoryLoading, 
        isSuccess: insertCordwoodHistoryIsSuccess,
        isError: insertCordwoodHistoryIsError,
        error: insertCordwoodHistoryError,
    }] = useInsertCordwoodHistoryMutation()
    
    const [deleteCordwoodHistoryMutation, { 
        isLoading: deleteCordwoodHistoryLoading,
        isSuccess: deleteCordwoodHistoryIsSuccess,
        isError: deleteCordwoodHistoryIsError,
        error: deleteCordwoodHistoryError,
    }] = useDeleteCordwoodHistoryMutation()

    const loading =
        insertCordwoodHistoryLoading ||
        
        deleteCordwoodHistoryLoading ||
        false

    const insertCordwoodHistory = useCallback(async (cordwoodHistory: CreateCordwoodHistory, redirectPath: string|undefined) => {
        try {
            const data = await insertCordwoodHistoryMutation(cordwoodHistory).unwrap()
            if (data) {
                if (redirectPath) {
                    if (redirectPath !== '.') {
                        navigate(redirectPath, {relative: 'path'})
                    }
                } else {
                    navigate(`../${data.id}`, {relative: 'path'})
                }
                return data;
            }
        } catch (e) {
            console.log("add error", e)
            openFailAlert(t`Add error: ` + e.toString())
        }
    }, [insertCordwoodHistoryMutation, navigate])
    
    useEffect(() => {
        if (insertCordwoodHistoryIsSuccess) {
            openSuccessAlert('Cordwood History created')
        } else if (insertCordwoodHistoryIsError) {
            console.log("add error", insertCordwoodHistoryError)
            openFailAlert(t`Cordwood History add error: ` + insertCordwoodHistoryError?.data?.message)
        }
    }, [
        insertCordwoodHistoryIsSuccess,
        insertCordwoodHistoryIsError,
        insertCordwoodHistoryError
    ]);

    

    const deleteCordwoodHistory = useCallback((cordwoodHistory: CordwoodHistory, redirectPath: string|undefined) => {
        openDialog(async () => {
            cordwoodHistory = {
                ...cordwoodHistory,
            }
            try {
                const { data } = await deleteCordwoodHistoryMutation(cordwoodHistory);
                if (data != null) {
                    if (redirectPath) {
                        navigate(redirectPath, {relative: 'path'})
                    }
                }
            } catch (e) {
                console.log("delete error", e)
                openFailAlert(t`Delete error: ` + e.toString())
            }
            closeDialog()
        });
    }, [deleteCordwoodHistoryMutation, closeDialog, openDialog])
    
    useEffect(() => {
        if (deleteCordwoodHistoryIsSuccess) {
            openSuccessAlert(t`Cordwood History deleted`)
        } else if (deleteCordwoodHistoryIsError) {
            console.log("delete error", deleteCordwoodHistoryError)
            openFailAlert(t`Cordwood History delete error: ` + deleteCordwoodHistoryError?.data?.message)
        }
    }, [
        deleteCordwoodHistoryIsSuccess,
        deleteCordwoodHistoryIsError,
        deleteCordwoodHistoryError
    ]);

    return {
        loading,
        insertCordwoodHistory,
        
        deleteCordwoodHistory
    }
}
